import Papa from 'papaparse';

import { ProjectFileUploadOptions } from 'src/store/state/projects';
import { formatSeparator } from 'src/utils/csv/formatSeparator';

export const unparseCsv = ({
  fields,
  rows,
  fileOptions,
}: {
  fields: string[];
  rows: string[][];
  fileOptions: ProjectFileUploadOptions;
}) => {
  return Papa.unparse(
    {
      fields,
      data: rows,
    },
    {
      // Unescape `\t` the way every reader does, so what we write can be
      // parsed back with the options stored beside it.
      delimiter: formatSeparator(fileOptions.separator),
      escapeChar: fileOptions.escape,
      header: fileOptions.header,
      quoteChar: fileOptions.quote,
    }
  );
};
